//课中活动讨论
export const ACTIVITY_LIST_INFO = 'activity_list_info'
export const Talk_LIST = 'talk_list'
export const Talk_INFO = 'talk_info'